import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { predictionService } from '../../services/predictionService';
import './Prediction.css';

export const PredictionList = () => {
  const [predictions, setPredictions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchPredictions = async () => {
    try {
      const data = await predictionService.getPredictions();
      console.log('Daily predictions data:', data);
      
      if (data && Array.isArray(data.predictions)) {
        setPredictions(data.predictions);
      } else {
        console.error('Unexpected data structure:', data);
        setError('Error: Formato de datos inesperado');
      }
    } catch (error) {
      console.error('Error fetching daily predictions:', error);
      setError('Error al cargar las predicciones diarias');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPredictions();
  }, []);

  const handleConsultaClick = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div className="prediction-page">
        <div className="loading">Cargando predicciones...</div>
      </div>
    );
  }

  return (
    <div className="prediction-page">
      <div className="prediction-container">
        <h1 className="prediction-title">Predicción Diaria del Tarot</h1>
        <div className="button-container">
          <button onClick={handleConsultaClick} className="consulta-button">
            Nueva Consulta
          </button>
        </div>
        
        {error && <div className="error">{error}</div>}
        
        <div className="prediction-grid">
          {predictions.length === 0 && !loading ? (
            <div className="no-predictions">
              <p>No hay predicciones disponibles. Vuelve mañana para ver la próxima predicción diaria.</p>
            </div>
          ) : (
            predictions.map(prediction => (
              <div key={prediction.id} className="prediction-card">
                <h2 className="post-title">{prediction.title}</h2>
                <div className="post-meta">
                  <span className="post-date">
                    {new Date(prediction.published_at).toLocaleDateString('es-ES', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </span>
                  {prediction.moon_phase && (
                    <span className="moon-phase">
                      Fase lunar: {prediction.moon_phase}
                    </span>
                  )}
                  {prediction.astro_sign && (
                    <span className="astro-sign">
                      Signo dominante: {prediction.astro_sign}
                    </span>
                  )}
                </div>
                <p className="post-summary">{prediction.summary}</p>
                <div className="post-content">{prediction.content}</div>
                <div className="post-tags">
                  {Array.isArray(prediction.tags) && prediction.tags.map(tag => (
                    <span key={tag} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}; 